import React from "react";
import { Checkbox, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { setActiveEvent } from "../../features/plan/PlanSlice";

import { useDispatch, useSelector } from "react-redux";
const { Title } = Typography;

const DuplicateEventSelector = (props) => {
  const { type, onDuplicateDaysChanged } = props;
  const dispatch = useDispatch();
  const activeEvent = useSelector((state) => state.plan.activeEvent);

  const options = [
    { value: 0, label: "א" },
    { value: 1, label: "ב" },
    { value: 2, label: "ג" },
    { value: 3, label: "ד" },
    { value: 4, label: "ה" },
    { value: 5, label: "ו" },
    { value: 6, label: "ש" },
  ];

  return (
    <div>
      <Title level={5}>
        {<FormattedMessage id="app.plans.duplicatePlanEventTitle" />}
      </Title>
      <Checkbox.Group
        options={options}
        onChange={(val) =>
          type === "plan"
            ? dispatch(
                setActiveEvent({ ...activeEvent, duplicateWeekdays: val })
              )
            : onDuplicateDaysChanged(val)
        }
      />
    </div>
  );
};

export default DuplicateEventSelector;
